enum ProcessingExecutionMode {
    SYNCHRONOUS = 'synchronous',

    /**
     * Asynchronous using Message queue (Pub/Sub)
     */
    ASYNCHRONOUS = 'asynchronous',
}
export default ProcessingExecutionMode;
